import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-more-query-options',
  templateUrl: './more-query-options.component.html',
  styleUrls: ['./more-query-options.component.scss']
})
export class MoreQueryOptionsComponent implements OnInit {

  @Input() attributes: any;
  selectedAttribute: any;

  constructor() { }

  ngOnInit() {
    if (this.attributes) {
      for (const attribute of this.attributes) {
        if (attribute.subType.length === 0) {
          this.selectedAttribute = attribute['attributeName'];
          break;
        }
      }
      if (!this.selectedAttribute) {
        this.selectedAttribute = 'field';
      }
    }
  }

}
